import React, { Component } from 'react'

export default class Info extends Component {
    render() {
        return (
            <div class="container" style={{
                marginTop : 0
            }}>
                <h3 class="fw-bold text-center">Nots.Art is a small validator dedicated to helping ensure the integrity of the Cosmos Ecosystem.</h3>

                <br/><br/><br/>
                <div class="row justify-content-center mt-5">
                    <div class="col-lg-4">
                        <div class="text-center card p-4">

                            {/* <h1 class="fw-bold">A New Place To Collect And Connect NFT Across.</h1> */}
                            <div class="d-flex align-items-center mt-4">
                                <img src='./images/airdrops.png' className='img-fluid' />
                            </div>
                            <br /> <br />
                            <p className='text-white'>
                                NFT airdrops to all stakers regardless of amount delegated.
                            </p>

                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="text-center card p-4">

                            {/* <h1 class="fw-bold">A New Place To Collect And Connect NFT Across.</h1> */}
                            <div class="d-flex align-items-center mt-4">
                                <img src='./images/love.png' className='img-fluid' height={200} />
                            </div>
                            <br /> <br />
                            <p className='text-white'>
                                We validate for various blockchains. We would love to earn your delegation and appreciate your trust in Nots.Art
                            </p>

                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="text-center card p-4">

                            {/* <h1 class="fw-bold">A New Place To Collect And Connect NFT Across.</h1> */}
                            <div class="d-flex align-items-center mt-4">
                                <img src='./images/stake.png' className='img-fluid' />
                            </div>
                            <br /> <br />
                            <p className='text-white'>
                                We offer discounts to our NFT holders who stake with us.
                            </p>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
